module.exports = __webpack_public_path__ + "media/images/lb/961-83a96b30b43128fca2a310c6cd563ffe.svg";